// ------------------------------------------------------------------------------
// name: UploadError
// author: mudas
// created: 2024-10-15
// ------------------------------------------------------------------------------

import { RcFile } from 'antd/es/upload/interface';
import { ChunkStatus } from './types';

export default class UploadError extends Error {
  constructor(
    message: string = 'Upload failed.',
    public file?: RcFile,
    public status?: ChunkStatus,
  ) {
    super(message);
  }
}
